module.exports = __webpack_public_path__ + "img/SUB.9028ec4a.svg";